import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const TOAST_HISTORY_LIMIT = 100

export type ToastHistoryType = 'success' | 'error' | 'info' | 'warning' | 'loading' | 'default'

export type ToastHistoryItem = {
  id: string
  type: ToastHistoryType
  title: string
  description: string
  /** epoch ms */
  createdAt: number
  /** epoch ms */
  updatedAt: number
}

export type ToastHistoryInput = Pick<ToastHistoryItem, 'id' | 'type' | 'title' | 'description'>

type ToastHistoryState = {
  /** 新しい順 */
  items: ToastHistoryItem[]
  /** 履歴を最後に開いた時刻 (epoch ms) */
  lastSeenAt: number
  upsert: (input: ToastHistoryInput) => void
  clear: () => void
  markSeen: () => void
}

export const useToastHistoryStore = create<ToastHistoryState>()(
  persist(
    (set) => ({
      items: [],
      lastSeenAt: 0,
      upsert: (input) =>
        set((state) => {
          const now = Date.now()
          const existing = state.items.find((item) => item.id === input.id)
          const others = state.items.filter((item) => item.id !== input.id)
          const next: ToastHistoryItem = { ...input, createdAt: existing?.createdAt ?? now, updatedAt: now }
          return { items: [next, ...others].slice(0, TOAST_HISTORY_LIMIT) }
        }),
      clear: () => set({ items: [] }),
      markSeen: () => set({ lastSeenAt: Date.now() }),
    }),
    {
      name: 'toast-history',
      partialize: (state) => ({ items: state.items, lastSeenAt: state.lastSeenAt }),
    },
  ),
)

export const selectUnreadToastCount = (state: ToastHistoryState): number =>
  state.items.filter((item) => item.updatedAt > state.lastSeenAt).length
